import styled from 'styled-components';

export const Container = styled.div`

`;

export const HeaderWrapper = styled.div`
    padding: 20px;
    .headerBox{
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title{
            font-size: 16px;
            font-weight: 700;
        }

        .icon{
            width: 30px;
        }
    }
`;

export const TypeSelectorWrapper = styled.div`
    display: flex;
    padding: 0 20px;
    gap: 8px;

    /* 선택 버튼 (에디터 새 디자인과 같은 모양) */
    button{
        flex: 1;
        height: 44px;
        border: none;
        border-radius: 12px;
        background: #fff;
        box-shadow: inset 0 0 0 1px #e5e7eb;
        font-size: 14px;
        font-weight: 600;
        color: #374151;
        transition: background 0.15s;

        &:hover{
            background: #f9fafb;
        }

        &.active{
            background: #111827;
            color: #fff;
            box-shadow: none;
        }
    }
`;

export const ImageSelectorWrapper = styled.div`
    padding: 0 20px;
    margin-top: 20px;
    .title{
        margin: 0;
        font-size: 16px;
    }

    .cardList{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .card{
        cursor: pointer;
        position: relative;
        width: 100px;
        box-sizing: border-box;
        border-radius: 15px;
        padding: 3px;

        img{
            border-radius: 15px;
        }
        &.active{
            border: 2px solid var(--mainColor);
        }
    }
`;

export const ColorSelectorWrapper = styled.div`
    padding: 0 20px;
    margin-top: 20px;
    .currentColorTitle{
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 5px;
    }

    .currentColor{
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        justify-content: flex-start;
        width: fit-content;
        .colorBox{
            width: 45px;
            height: 45px;
            background-color: red;
            border-radius: 45px;
            border: 1px solid #f0f0f0;
        }

        .colorHex{
            font-weight: 700;
        }
    }

    .sampleColorList{
        margin-top: 20px;
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        .colorBox{
            cursor: pointer;
            width: 40px;
            height: 40px;
            background-color: red;
            border-radius: 40px;
            border: 1px solid #f0f0f0;
        }
    }
`;

export const FooterWrapper = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    padding: 0 20px;
    justify-content: flex-end;

    button{
        width: 80px;
        height: 40px;
        border-radius: 10px;
        background: #111827;
        color: #fff;
        border: none;
        font-weight: 700;
    }

`;